import { ELanguage } from './language';

interface RouteLangParams {
  type: 'football' | 'team' | 'match' | 'league';
  lang: ELanguage;
}

/**
 * Given a type and a language, returns the corresponding route string.
 * If the type or language is not found, returns an empty string.
 *
 * @param {RouteLangParams} params
 * @returns {string}
 */
export function routesLang({ type, lang }: RouteLangParams): string {
  const routes: Record<typeof type, Record<typeof lang, string>> = {
    football: { es: 'futbol', en: 'football' },
    team: { es: 'equipo', en: 'team' },
    league: { es: 'liga', en: 'league' },
    match: { es: 'partido', en: 'match' },
  };

  return routes[type]?.[lang] || '';
}
